<template>
  <div class="icerik">
    <el-row :gutter="24">
      <Yukleniyor :data="lo"></Yukleniyor>
      <el-col :span="4" v-for="f in Firsatlar">
        <div class="firsatkutu">
          <img :src="f.Resim.Url+f.Resim.Data">
          <div class="firsatdetay">
            <h5>{{f.Baslik}}</h5>
            <h6>{{f.Aciklama}}</h6>
            <h3>{{f.Telefon}}</h3>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
  import Yukleniyor from "../../components/Doc/Yukleniyor";

  export default {
    components: {Yukleniyor},
    data() {
      return {
        lo: false,
        ModalOlayi: false,
        Firsatlar: [],
        Detay: null
      }
    },
    methods: {
      KampanyaDetay(detay) {
        this.Detay = detay;
        this.ModalOlayi = true;
      },
      SayfaYukle() {
        this.lo = true;
        this.$store.dispatch("Get", {path: 'kilavuz/firsat/' + this.$store.getters.Paket})
          .then(response => {
            this.lo = false;
            if (response.Durum === 'OK') {
              this.Firsatlar = response.Data;
            } else {
              this.$message.error(response.Mesaj);
              this.hata = response.Hata;
            }
          });
      }
    },
    created() {
      this.SayfaYukle();
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Doc/IndexBlok.vue